import { css } from '@emotion/react';

const makeTextFieldInputStyling = ({ theme }) => {
  return {
    box: css({
      marginBottom: theme.mvf.spacing.medium,
      marginTop: theme.mvf.spacing.medium,
    }),
    textFieldBox: css({
      marginTop: theme.mvf.spacing.medium,
      position: 'relative',
      overflow: 'visible',
      width: '100%',
    }),
    popper: css({
      zIndex: 2000,
      marginTop: '2px',
      // No left override to allow natural positioning
    }),
    suggestionsPaper: css({
      width: '100%',
      borderRadius: theme.shape.borderRadius,
      maxHeight: 200,
      overflow: 'auto',
    }),
    suggestionsList: css({
      padding: 0,
    }),
  };
};

export default makeTextFieldInputStyling;
